// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { SuccessToast } from "../../ToastComponent";

// export const DeskModal = ({ DeskDataFetchFunc, selectedItem }) => {

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: Number,
//     ApplicationNo: "",
//     LoanNumber: "",
//     Remark: "",
//     purpose: Number,
//     Latitude: "",
//     Longitude: "",

//   });

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === 'true');

//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const formData = new FormData();
//   formData.append("BranchId", LocalFormData.BranchId);
//   formData.append("ApplicationNo", LocalFormData.ApplicationNo);
//   formData.append("LoanNumber", LocalFormData.LoanNumber);
//   formData.append("Remark", LocalFormData.Remark);
//   formData.append("purpose", LocalFormData.purpose);
//   formData.append("Latitude", LocalFormData.Latitude);
//   formData.append("Longitude", LocalFormData.Longitude);

//   const HandleSubmit = async () => {
//     // console.log(LocalFormData)
//     try {
//       const response = await axios.post(`${Api_Url}api/v1/DeskWork`, formData, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log(response)
//       DeskDataFetchFunc()
//       resetForm()
//       SuccessToast("DeskWork Submitted Successfully")
//     } catch (error) {
//       return error.message
//     }
//   }

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//     ApplicationNo: "",
//     LoanNumber: "",
//     Remark: "",
//     purpose: Number,
//     });
//   };

//   const [allbranch, setAllBranch] = useState('')

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`
//         }
//       })
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object", error)
//     }
//   }

//   useEffect(() => {
//     AllBranchName()
//   }, [])

//   const datastatus =[
//     {
//         id: 1,
//         label: "Calling..", value: "Calling..",

//     },
//     {
//         id: 2,
//         label: "File Completion", value: "File Completion",
//     },
//     {
//         id: 3,
//         label: "Training", value: "Training",
//     },
//     {
//         id: 4,
//         label: "Meeting with Reporting Manager", value: "Meeting with Reporting Manager",
//     },
//     {
//         id: 5,
//         label: "Cutomer Meeting", value: "Cutomer Meeting",
//     },
// ]

//   const [singledata, setSingleData] = useState({

//   });

//   const GetSingleId = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/DeskWork/${selectedItem}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response.data.data)
//       setSingleData(response.data.data)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     GetSingleId()
//   }, [selectedItem]);

//   const UpdatedeskFunc = async() => {
//     try {
//       console.log("singledata", singledata)
//       const response = await axios.put(`${Api_Url}api/v1/DeskWork/${selectedItem}`,singledata,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response.data.data)
//       // setSingleData(response.data.data)
//       DeskDataFetchFunc()
//     } catch (error) {
//       return error
//     }
//   }

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Desk Work</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Purpose <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.purpose}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, purpose: e.target.value })}
//                       >
//                         <option value="">Select purpose</option>
//                         {datastatus.map((purpose)=>(
//                           <option key={purpose.id} value={purpose.id}>{purpose.label}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Application Number <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" placeholder="Application Number" type="text" value={LocalFormData.ApplicationNo} onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Loan Number <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" placeholder="Loan Number" value={LocalFormData.LoanNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, LoanNumber: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Remark <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="text" placeholder="Enter Remark" value={LocalFormData.Remark} onChange={(e) => setLocalFormData({ ...LocalFormData, Remark: e.target.value })} />
//                     </div>
//                   </div>
//                   {/* <label className="col-form-label">
//                     Purpose Met<span className="text-danger">*</span>
//                   </label> */}

//                   {/* <div className="col-md-12">
//                     <label className="col-form-label">
//                       EMI Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={radioValue === true}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={radioValue === false}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={radioValue === false}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Not Collected
//                       </label>
//                     </div>
//                   </div> */}

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {radioValue === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Refference Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           placeholder="Enter your reference number"
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={singledata.branchId}
//                         onChange={(e) => setSingleData({ ...singledata, branchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Purpose <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={singledata.purpose}
//                         onChange={(e) => setSingleData({ ...singledata, purpose: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {datastatus.map((purpose)=>(
//                           <option key={purpose.id} value={purpose.id}>{purpose.value}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Application Number <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={singledata.applicationNo} onChange={(e) => setSingleData({ ...singledata, applicationNo: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Loan Number <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="text" value={singledata?.loanNumber} onChange={(e) => setSingleData({ ...singledata, loanNumber: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Remark <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="text" value={singledata.remark} onChange={(e) => setSingleData({ ...singledata, remark: e.target.value })} />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={()=>UpdatedeskFunc(selectedItem)}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// MOdal

import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const DeskModal = ({ DeskDataFetchFunc, selectedItem, onClose }) => {
  const [radioValue, setRadioValue] = useState(false);
  const [loading, setLoading] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: null,
    ApplicationNo: "",
    LoanNumber: "",
    Remark: "",
    purpose: null,
    Latitude: null,
    Longitude: null,
  });

    useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {

        const { latitude, longitude } = position.coords;
        setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [])

  const datastatus = [
    { label: "Document Verification", value: 1 },
    { label: "Document Retrieval", value: 2 },
  ];

  const [allbranch, setAllBranch] = useState([]);
  const [singledata, setSingleData] = useState({});

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          },
        });
        setAllBranch(response.data.data);
      } catch (error) {
        console.log("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    const fetchSingleData = async () => {
      try {
        const response = await axios.get(`${Api_Url}api/v1/DeskWork/${selectedItem}`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          },
        });
        setSingleData(response.data.data);
      } catch (error) {
        console.log("Error fetching desk work data:", error);
      }
    };

    if (selectedItem) {
      fetchSingleData();
    }
  }, [selectedItem]);

  const validateForm = () => {
    if (!LocalFormData.BranchId) {
      ErrorToast("Please select a branch.");
      return false;
    }
    if (!LocalFormData.purpose) {
      ErrorToast("Please select a Purpose.");
      return false;
    }
    if (!LocalFormData.ApplicationNo) {
      ErrorToast("Please enter an Application Number.");
      return false;
    }
    if (!LocalFormData.LoanNumber) {
      ErrorToast("Please enter a Loan Number.");
      return false;
    }
    if (!LocalFormData.Remark) {
      ErrorToast("Please enter a Remark.");
      return false;
    }
    return true;
  };

  const HandleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("ApplicationNo", LocalFormData.ApplicationNo);
    formData.append("LoanNumber", LocalFormData.LoanNumber);
    formData.append("Remark", LocalFormData.Remark);
    formData.append("purpose", LocalFormData.purpose);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(`${Api_Url}api/v1/DeskWork`, formData, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
        },
      });
      DeskDataFetchFunc();
      resetForm();
      SuccessToast("DeskWork Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting.");
      console.log("Submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: null,
      ApplicationNo: "",
      LoanNumber: "",
      Remark: "",
      purpose: null,
      Latitude: null,
      Longitude: null,
    });
  };

  return (
    <Modal
      title={<h4>Desk Work</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div className="d-flex justify-content-between align-items-center" key="footer">
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={HandleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.BranchId}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      BranchId: e.target.value,
                    })
                  }
                >
                  <option value="">Select Branch</option>
                  {allbranch.map((res) => (
                    <option key={res.id} value={res.id}>
                      {res.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Purpose <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.purpose}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      purpose: e.target.value,
                    })
                  }
                >
                  <option value="">Select Purpose</option>
                  {datastatus.map((purpose) => (
                    <option key={purpose.id} value={purpose.value}>
                      {purpose.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Application Number <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Application Number"
                  type="text"
                  value={LocalFormData.ApplicationNo}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      ApplicationNo: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Loan Number <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  placeholder="Loan Number"
                  value={LocalFormData.LoanNumber}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      LoanNumber: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Remark <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Remark"
                  value={LocalFormData.Remark}
                  onChange={(e) =>
                    setLocalFormData({
                      ...LocalFormData,
                      Remark: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
